<template>
  <div class="item-wrapper">
    <div class="item">
      <img :src="mini(data.cover_img_url, { w: 190, limit: 1 })" />
      <!-- <img :src="data.cover_img_url" width="190" /> -->
      <div class="mask">
        <div class="action" @click="selectTpl(data)">使用此模板</div>
        <div v-if="data.is_creator" class="action" @click="edit(data)">
          编辑模板
        </div>
        <div
          v-if="isHasPermission"
          class="action"
          @click="showRemoveConfirmBox(data.id)"
        >
          删除
        </div>
        <div class="action" @click="preview(data.cover_img_url)">预览</div>
      </div>
    </div>
    <div class="content">
      <div
        class="avator"
        v-if="data.created_by"
        :style="{
          background: data.color,
        }"
      >
        {{ data.created_by }}
      </div>

      <el-tooltip
        :content="data.template_name"
        placement="bottom"
        effect="light"
      >
        <div class="text">{{ data.template_name }}</div>
      </el-tooltip>

      <div class="date">{{ data.create_time }}</div>
    </div>
  </div>
</template>

<script>
import bus from "@/js/common/bus.js";
import { mini } from "@/js/miniImg";
export default {
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
  computed: {
    isHasPermission() {
      // 是否有删除和修改的权限
      const authStr = decodeURIComponent(lib.cookie.get("authority") || "");
      return authStr.includes("3");
    },
  },
  methods: {
    //使用模板
    mini,
    selectTpl(item) {
      this.$router.push({
        path: "/tms",
        query: {
          template_id: item.id,
        },
      });
    },
    showRemoveConfirmBox(id) {
      this.$confirm("确认删除该模板?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => this.confirmDeleteTemplate(id))
        .catch((error) => {
          if (error === "cancel") {
            // console.log('已取消');
          } else {
            this.$message.error("系统错误");
          }
        });
    },
    //删除模板
    confirmDeleteTemplate(id) {
      lib.tmsapi.post({
        api: "api/test/template/del",
        data: {
          id: id,
        },
        success: (res) => {
          // 关闭弹框
          this.$message.success("删除页面成功");
          // 添加成功，刷新列表
          bus.$emit("refreshTable", 1);
          // this.getTemplateList(1);
        },
      });
    },

    edit(item) {
      this.$router.push({
        path: "/tms",
      });
    },
    preview (src) {
      this.$emit('preview', src)
    }
  },
};
</script>

<style lang="scss" scoped>
.item-wrapper {
  width: 190px;
  margin-bottom: 20px;
  margin-right: 20px;
  &:hover {
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  }
  .item {
    min-height: 190px;
    max-height: 304px;
    border: 1px solid #e4e7ed;
    position: relative;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    .mask {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      visibility: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      border-radius: 8px 8px 0 0;
      background: rgba(0, 0, 0, 0.7);
      .action {
        width: 50%;
        text-align: center;
        padding: 6px 0;
        border-radius: 4px;
        border: 1px solid #fff;
        font-size: 14px;
        color: #fff;
        margin-bottom: 10%;
        cursor: pointer;
      }
    }
    &:hover {
      .mask {
        visibility: visible;
      }
    }
  }
  .content {
    position: relative;
    padding: 10px 10px;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: flex-start;
    border-radius: 0 0 8px 8px;
    border: 1px solid #e4e7ed;
    border-top: 0px solid transparent;
    background: #fff;
    .avator {
      width: 30px;
      height: 30px;
      border-radius: 100%;
      color: #fff;
      font-size: 10px;
      text-align: center;
      line-height: 30px;
      background: red;
      margin-right: 5px;
    }
    .text {
      width: 50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
    }
    .date {
      position: absolute;
      right: 5px;
      font-size: 10px;
      color: #999999;
      line-height: 10px;
    }

    :last-child {
      margin-left: 10px;
    }
  }
}
</style>
